import { useState, useMemo, useCallback } from 'react';
import { useStateSelector } from 'hooks';

import { format } from 'date-fns';
import { serviceDateFormat } from 'utils';

import { getCurrentCooperative } from 'store/home/selectors';

import { InvestorTenantsDetails } from 'components';

function buildURL(coopId: string, date: Date) {
  const searchParams = `date=${format(date, serviceDateFormat)}`;

  return `/api/portfolios/${coopId}/tenant?${searchParams}`;
}

interface InvestorTenantsState {
  date: Date | null;
}

const InvestorTenants = () => {
  const { coopId, coopName } = useStateSelector((state) => ({
    coopId: state.settings.current_cooperative,
    coopName: getCurrentCooperative(state)?.Name || null,
  }));
  const [state, setState] = useState<InvestorTenantsState>({
    date: new Date(),
  });

  const handleChangeDate = useCallback((date: Date | null) => {
    setState((prevState) => ({ ...prevState, date }));
  }, []);

  const url = useMemo(() => {
    if (coopId && state.date) {
      return buildURL(coopId, state.date);
    }

    return null;
  }, [state.date, coopId]);

  const fileName = useMemo(() => {
    return `investor_tenants__${coopName}`;
  }, [coopName]);

  return (
    <InvestorTenantsDetails
      date={state.date}
      fileName={fileName}
      url={url}
      handleChangeDate={handleChangeDate}
    />
  );
};

export default InvestorTenants;
